import { useSuspenseQuery } from '@tanstack/react-query';
import { categoryService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useIconsAll = () => {
  return useSuspenseQuery({
    queryKey: queryKey.iconsAll(),
    queryFn: () => categoryService.getIconsAll(),
  });
};
